/* website-builder: small runtime helpers for cloned pages. */
(() => {
  // Live dates (delivery estimates): the same number of days ahead as on the source, in the page's language.
  const lang = document.documentElement.lang || 'en';
  document.querySelectorAll('.c-date[data-days]').forEach((el) => {
    const d = new Date(Date.now() + Number(el.dataset.days) * 864e5);
    const opts = el.dataset.weekday === 'true' ? { weekday: 'short', day: 'numeric', month: 'short' } : { day: 'numeric', month: 'long' };
    try {
      el.textContent = new Intl.DateTimeFormat(lang, opts).format(d);
    } catch {}
  });

  // Clicks recorded from a custom-coded source page (capture-custom.ts), replayed without its scripts:
  //   data-c-toggle="k" on the button; data-c-swap="k …" on the element it changes, whose content
  //   after the click is kept in [data-c-state="k"]; data-c-scroll="k" jumps to [data-c-anchor="k"].
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-c-toggle], [data-c-scroll]');
    if (!t || t.closest('[data-c-states]')) return;
    if (t.dataset.cScroll) {
      const to = document.querySelector(`[data-c-anchor~="${t.dataset.cScroll}"]`);
      if (to) {
        e.preventDefault();
        to.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    const k = t.dataset.cToggle;
    const box = document.querySelector(`[data-c-swap~="${k}"]`);
    const state = document.querySelector(`[data-c-state="${k}"]`);
    if (!box || !state) return;
    e.preventDefault();
    if (box.dataset.cShown === k) {
      box.innerHTML = box._cBase;
      delete box.dataset.cShown;
    } else {
      if (!box.dataset.cShown) box._cBase = box.innerHTML;
      box.innerHTML = state.innerHTML;
      box.dataset.cShown = k;
    }
  });
})();
